import React, { useEffect, useState } from "react";
import {
  ArrowLeftOutlined,
  CaretLeftOutlined,
  CaretRightOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { DatePicker, Select, Input, Tooltip, Col, Row, Typography, Spin } from "antd";
import NeetBarGraph from "./localComponents/classBarGraph";
import StudentGraph from "./localComponents/studentGraph";
import Progress from "antd/lib/progress";
import { useHistory } from "react-router";
import { fetchClassDashboard, setEndDate, setStartDate } from "actions/attendanceNew";
import { connect } from "react-redux";
import { Api } from 'services';
import PageDataLoader from "components/pageDataLoader";
import { setUserDetails } from "actions/userManagementV2";
import { setSpecificUserId } from "actions/userManagement";
import { SquareSubIcon, SubIcon } from 'components/subIcon'
import { setOverviewFilter } from "actions/feeManagement";
import { setOthersSelectedTab } from "actions/profileNew";
import moment from "moment";

const { RangePicker } = DatePicker;

const getInitials = (name) => {
    if (!name) return "";
    const cleanName = name.replace(/[^a-zA-Z\s_]/g, "").trim();
    const parts = cleanName.split(/[\s_]+/);
    if (parts.length === 0 || parts[0] === "") {
        return name.slice(0, 2).toUpperCase();
    }
    if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase();
    }
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const getAvatarColor = (name) => {
    const colors = [
        { bg: "#E8EAF6", text: "#3F51B5" },
        { bg: "#E0F2F1", text: "#00796B" },
        { bg: "#FCE4EC", text: "#C2185B" },
        { bg: "#FFF3E0", text: "#E65100" },
        { bg: "#E8F5E9", text: "#2E7D32" },
        { bg: "#F3E5F5", text: "#7B1FA2" },
        { bg: "#E0F7FA", text: "#00838F" },
        { bg: "#ECEFF1", text: "#37474F" }
    ];
    if (!name) return colors[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
};

const hasNoImage = (imgUrl) => {
    return !imgUrl || 
           imgUrl === "null" || 
           imgUrl === "undefined" || 
           imgUrl === "" || 
           imgUrl === "default.png" ||
           imgUrl.includes("default.png") ||
           imgUrl.includes("com-default-pic.svg") ||
           imgUrl.includes("awesome-user-alt");
};

export function NodataCard({
  containerheight = "80%",
  imgwidth = "30%",
  imgheight = "30%",
}) {
  return (
    <div className="r-c-c-c" style={{ height: containerheight }}>
      <img
        style={{ width: imgwidth, height: imgheight, marginBottom: "20px" }}
        src={require("../../Assets/test/no-subjects.svg").default}
        alt=""
      />
      <div className="r-c-c-c">
        <h1 style={{ fontFamily: "roboto", fontWeight: "800" }}>No data!</h1>
        <p style={{ color: "#636363", fontFamily: "roboto" }}>
          There is no data to show yet. Please check back later.
        </p>
      </div>
    </div>
  );
}

const bodyStyle = {
  background: "#FAFAFA",
  width: "calc(100% + 30px)",
  height: "calc(100% + 40px)",
  margin: -20,
  padding: 20,
  overflow: "auto",
};

const PageHeader = ({ goBack, classDashboardData }) => {
  return (
    <div className="resultPageHeader full-width">
      <div className="r-c-fs m-r-30">
        <ArrowLeftOutlined
          onClick={goBack}
          style={{ fontSize: 18, color: "#191919" }}
          className="cursor-pointer"
        />
        <div className="text-md bold-700 m-l-20">
          {classDashboardData?.className}
        </div>
      </div>
    </div>
  );
};

const StudentCard = ({ classDashboardData }) => {
  return (
    <div
      className="border-16 boxShadow118"
      style={{
        width: "96%",
        height: "350px",
        // borderRadius: 2,
        backgroundColor: "#FFFFFF",
        borderColor: "#E6E6E6",
        border: "solid 1px #E6E6E6"
      }}
    >
      <div style={{ padding: 20 }}>
        <div style={{ fontSize: "15px", color: "#191919", fontWeight: "bold", fontFamily: "roboto" }}>
          Today’s attendance
        </div>
        <div style={{ fontSize: "9px", color: "#636363" }}>
          {classDashboardData?.todaysAttendance?.date} {"•"}  {classDashboardData?.todaysAttendance?.day}
        </div>
      </div>
      <div style={{ marginTop: -70 }}>
        {classDashboardData?.todaysAttendance?.present || classDashboardData?.todaysAttendance?.absent ?
          <StudentGraph
            overall={classDashboardData?.todaysAttendance?.present}
            presentVal={classDashboardData?.todaysAttendance?.present}
            absentVal={classDashboardData?.todaysAttendance?.absent}
          />
          :
          <center style={{ marginTop: 110, width: '80%', marginLeft: 30 }}><NodataCard /></center>}
      </div>
    </div>
  );
};

const StudentBarCard = ({ classDashboardData, setStartDate, setEndDate, startDate, endDate, fetchClassDashboard }) => {
  const [graph, setGraph] = useState([])
  const [isDateLoading, setIsDateLoading] = useState(false);
  const [hackValue, setHackValue] = useState(null);
  useEffect(() => {
    let temp = [];
    for (let i = 0; i < classDashboardData?.todaysAttendanceByClass?.length; i++) {
      let obj = {}
      obj['subjectName'] = classDashboardData?.todaysAttendanceByClass[i].subjectName,
        obj['key'] = classDashboardData?.todaysAttendanceByClass[i].key
      obj['range'] = classDashboardData?.todaysAttendanceByClass[i].presentPercentage,
        obj['presentCount'] = classDashboardData?.todaysAttendanceByClass[i].presentCount,
        obj['icon'] = classDashboardData?.todaysAttendanceByClass[i].icon,
        obj['teacherName'] = classDashboardData?.todaysAttendanceByClass[i].teacherName,
        obj['name'] = 'Present count %'
      temp.push(obj);

      let obj1 = {}
      obj1['subjectName'] = classDashboardData?.todaysAttendanceByClass[i].subjectName,
        obj1['key'] = classDashboardData?.todaysAttendanceByClass[i].key
      obj1['range'] = classDashboardData?.todaysAttendanceByClass[i].absentPercentage,
        obj1['absentCount'] = classDashboardData?.todaysAttendanceByClass[i].absentCount,
        obj1['icon'] = classDashboardData?.todaysAttendanceByClass[i].icon
      obj1['teacherName'] = classDashboardData?.todaysAttendanceByClass[i].teacherName,
        obj1['name'] = 'Absent count %'
      temp.push(obj1);
    }
    setGraph([...temp])
  }, [classDashboardData?.todaysAttendanceByClass]);

  return (
    <div
      className="border-16 boxShadow118"
      style={{
        width: "100%",
        height: "350px",
        backgroundColor: "#FFFFFF",
        borderColor: "#E6E6E6",
        border: "solid 1px #E6E6E6",
        padding: 20
      }}
    >
      <div className="r-c-sb" style={{width:"100%"}}>
      <div
        style={{
          color: "#191919",
          fontWeight: "bold",
          fontSize: "15px",
          fontFamily: "roboto",
          width:"30%"
        }}
      >
        Attendance by class
      </div>
      <div style={{ display: "flex",width:"30%" }}>
        <div style={{ display: "flex"}}>
          <div style={{ display: "flex", marginLeft: 45 }}>
            <div
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#28DF99",
                marginRight: "10px",
                marginTop: "2px",
                marginLeft: "20px"
              }}
            ></div>
            <div style={{ fontSize: "9px", color: "#636363", fontFamily: "roboto", }}>Present</div>
            <div
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#FF414D",
                marginRight: "10px",
                marginTop: "2px",
                marginLeft: "10px",
                marginLeft: "10px"
              }}
            ></div>
            <div style={{ fontSize: "9px", color: "#636363", fontFamily: "roboto" }}>Absent</div>
          </div>
        </div>
      </div>
      <div style={{ width:"40%"}}>
             <RangePicker
              format={'DD-MM-YYYY'}
              getPopupContainer={(trigger) => trigger.parentElement}
              value={hackValue !== null ? hackValue : [startDate ? moment(startDate) : null, endDate ? moment(endDate) : null]}
              onChange={(value1, value) => {
                setHackValue(null);
                if (!value1 || value1.length === 0 || !value1[0] || !value1[1]) {
                  setStartDate(moment().startOf("week").format("YYYY-MM-DD"))
                  setEndDate(moment().endOf("week").format("YYYY-MM-DD"))
                } else {
                  if (value1[1].diff(value1[0], 'days') + 1 > 7) return;
                  setStartDate(value1[0].format("YYYY-MM-DD"))
                  setEndDate(value1[1].format("YYYY-MM-DD"))
                }
                setIsDateLoading(true);
                fetchClassDashboard(() => {
                  setIsDateLoading(false);
                });
              }}
              disabledDate={(current) => {
                if (!hackValue || !hackValue[0]) return false;
                return current.diff(hackValue[0], 'days') > 6 || hackValue[0].diff(current, 'days') > 6;
              }}
              onCalendarChange={(val) => setHackValue(val)}
              onOpenChange={(open) => { if (open) setHackValue([null, null]); else setHackValue(null); }}
            />
          </div>
          </div>
      {isDateLoading ? (
        <div style={{ width: "90%", height: "80%", minHeight: "200px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      ) : (
        <div
          style={{ width: "90%", height: "80%", marginTop: 50, marginLeft: 20 }}
        >
          {graph && graph.length === 0 ? <NodataCard /> : <NeetBarGraph data={graph?.length != 0 ? graph : []} />}
        </div>
      )}
    </div>
  );
};


const SubjectCard = ({ item }) => {

  return (
    <div
      className="border-16 boxShadow118"
      style={{
        minWidth: 290,
        alignItems: "center",
        border: "#E6E6E6 solid 1px",
        // borderRadius: "2px",
        padding: "10px",
        paddingTop: "10px",
        height: "150px",
        marginRight: 10,
        borderColor: "#E6E6E6",
        backgroundColor: "#FFFFFF",
        marginTop: "20px",
      }}
    >
      <div style={{ display: "flex", marginTop: "10px" }}>
        <div>
          <SubIcon style={{ width: "60%" }} icon={item?.icon} name={item?.subjectName} size={60} />
        </div>
        <div style={{ marginLeft: "30px" }}>
          <div
            style={{ fontSize: "13px", color: "#191919", fontWeight: "bold", marginLeft: -20 }}
          >
            {item?.subjectName}
          </div>
          <div
            style={{ fontSize: "10px", color: "#636363", marginLeft: -20 }}
          >
            {item?.teacherName}
          </div>
        </div>
      </div>

      <div style={{ marginTop: "15px" }}>
        <Progress
          percent={item?.averageAttendance}
          style={{ marginTop: -20 }}
          showInfo={false}
          strokeColor="#594099"
          trailColor="#F6F4FE"
        />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", fontFamily: "roboto" }}>
        <div>Average attendance</div>
        <div>{item?.averageAttendance}%</div>
      </div>
    </div>
  );
};

const AllStudentCard = ({
  setSpecificUserId,
  studentId,
  image,
  sname,
  rollno,
  percent,
  setOverviewFilter,
  item,
  setOthersSelectedTab,
  setUserDetails
}) => {
  const history = useHistory();
  console.log({ item })

  // //append role: ['Student'] to the item... 
  // const newItem = { ...item };
  // newItem.role = ['Student'];

  // console.log({ newItem })

  return (
    <div
      className="border-16 boxShadow118"
      style={{
        width: "290px",
        alignItems: "center",
        border: "#E6E6E6 solid 1px",
        // borderRadius: "6px",
        padding: "10px",
        paddingTop: "10px",
        height: "100px",
        marginRight: 10,
        borderColor: "#E6E6E6",
        backgroundColor: "#FFFFFF",
        marginTop: 15,
        cursor: "pointer",
        marginLeft: "2px",
      }}
      onClick={() => {
        history.push({
          pathname: "/user-management/profile",
          state: {
            key: true
          }
        });
        setUserDetails(item?.user)
        setSpecificUserId(item?.user?.id);
        setOverviewFilter("userId", item?.user?.id);
        setOthersSelectedTab('Basic Profile')
      }}
    >
      <div
        style={{
          display: "flex",
          marginTop: 0
        }}
      >
        <div>
          {hasNoImage(item?.user?.image) ? (
            <div style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: getAvatarColor(sname).bg,
              color: getAvatarColor(sname).text,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px",
              fontWeight: "600",
              textTransform: "uppercase",
              marginTop: 10,
              marginLeft: 20,
              marginRight: 20
            }}>
              {getInitials(sname)}
            </div>
          ) : (
            <img style={{ width: 60, height: 60, borderRadius: '50%', marginTop: 10, marginLeft: 20, marginRight: 20, objectFit: "cover" }} src={image} />
          )}
        </div>
        <div style={{ marginTop: 10 }}>


          <div>
            <Typography.Text style={{ fontSize: "13px", color: "#191919", fontWeight: "bold", marginTop: "10px", width: "100px" }} ellipsis={{ tooltip: true }}>
              {sname}
            </Typography.Text>
          </div>
          {/* <div
              style={{ fontSize: "13px", fontWeight: "bold", color: "#191919" }}
            >
              {sname}
            </div> */}
          <div style={{ fontSize: "11px", color: "#636363", fontFamily: "roboto" }}>
            Roll No: {rollno}
          </div>
          <div style={{ fontSize: "9px", color: "#636363" }}>
            {percent}%
          </div>
        </div>
      </div>
    </div>
  );
}

function ClassPage({ fetchClassDashboard, classDashboardData, studentPageLoader, setSpecificUserId, setOverviewFilter, setOthersSelectedTab, setUserDetails, setStartDate, setEndDate, startDate, endDate }) {

  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };

  const [isInitialLoading, setIsInitialLoading] = useState(true);

  useEffect(() => {
    setStartDate(moment().startOf("week").format("YYYY-MM-DD"));
    setEndDate(moment().endOf("week").format("YYYY-MM-DD"));
    fetchClassDashboard(() => {
      setIsInitialLoading(false);
    });
  }, [])

  return (
    <div style={bodyStyle}>
      <div>
        <PageHeader
          goBack={goBack}
          classDashboardData={classDashboardData}
        />
      </div>
      <Row style={{ marginTop: "10px" }}>
        <Col md={{ span: 24 }} xl={{ span: 8 }} sm={{ span: 24 }} lg={{ span: 24 }}>

          <StudentCard
            classDashboardData={classDashboardData} />
        </Col>
        <Col md={{ span: 24 }} xl={{ span: 16 }} sm={{ span: 24 }} lg={{ span: 24 }}>
          <StudentBarCard
            classDashboardData={classDashboardData} 
            setStartDate = {setStartDate} 
            setEndDate={setEndDate} 
            startDate={startDate}
            endDate={endDate}
            fetchClassDashboard={fetchClassDashboard}
          />
        </Col>
      </Row>

      <div style={{ display: "flex", marginTop: "20px" }}>
        <div style={{ fontSize: "15px", color: "#191919", fontWeight: "bold", fontFamily: "roboto" }}>
          Subjects
        </div>
        <div style={{ fontSize: "15px", color: "#AEAEAE", marginLeft: 5 }}>({classDashboardData?.subjects?.length})</div>
      </div>
      <div
        className="p-5 scroll-bar-universal "
        style={{ display: "flex", marginTop: "-10px", }}
      >
        {classDashboardData?.subjects?.map((item) => (
          <SubjectCard
            item={item}
          />
        ))}
        {classDashboardData?.subjects.length === 0 ? <div style={{ display: 'flex', justifyContent: 'center', marginLeft: '28vw' }}><NodataCard /></div> : null}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <div style={{ fontSize: "15px", color: "#191919", fontWeight: "bold", fontFamily: "roboto" }}>
          All students{" "}
        </div>
        {classDashboardData?.students?.length >= 4 ?
          <div
            onClick={() => {
              history.push("student-detail-page");
            }}
            style={{
              fontSize: "11px",
              color: "#1089FF",
              fontWeight: "bold",
              cursor: "pointer",
              fontFamily: "roboto",
              marginRight: "8px"
            }}
          >
            VIEW ALL
          </div>
          : null}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {classDashboardData?.students?.map((item, i) => (
          <>
            {i < 5 && (
              <AllStudentCard
                item={item}
                setSpecificUserId={setSpecificUserId}
                studentId={item.user.id}
                sname={item?.user?.name}
                rollno={item.rollNo}
                percent={item.averageAttendance}
                image={`${Api._s3_url}${item?.user?.image}`}
                setOverviewFilter={setOverviewFilter}
                setOthersSelectedTab={setOthersSelectedTab}
                setUserDetails={setUserDetails}
              // history={history}
              />
            )}
          </>


        ))}
      </div>
      <PageDataLoader visible={studentPageLoader && isInitialLoading} />
    </div>
  );
}

const mapStateToProps = (state) => {
  const { classDashboardData, studentPageLoader, startDate, endDate } = state.attendanceNew;
  return { classDashboardData, studentPageLoader, startDate, endDate };
};

const mapDispatchToProps = (dispatch) => ({
  fetchClassDashboard: (callback) => dispatch(fetchClassDashboard(callback)),
  setSpecificUserId: (val) => dispatch(setSpecificUserId(val)),
  setOverviewFilter: (key, val) => dispatch(setOverviewFilter(key, val)),
  setOthersSelectedTab: tab => dispatch(setOthersSelectedTab(tab)),
  setUserDetails: res => dispatch(setUserDetails(res)),
  setStartDate: (val) => dispatch(setStartDate(val)),
  setEndDate: (val) => dispatch(setEndDate(val)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClassPage);

